import './notification-drawer.css';
export default {
  "dirRtl": "pf-v6-m-dir-rtl",
  "modifiers": {
    "info": "pf-m-info",
    "warning": "pf-m-warning",
    "danger": "pf-m-danger",
    "success": "pf-m-success",
    "custom": "pf-m-custom",
    "read": "pf-m-read",
    "hoverable": "pf-m-hoverable",
    "truncate": "pf-m-truncate",
    "noOffset": "pf-m-no-offset",
    "expanded": "pf-m-expanded"
  },
  "notificationDrawer": "pf-v6-c-notification-drawer",
  "notificationDrawerBody": "pf-v6-c-notification-drawer__body",
  "notificationDrawerGroup": "pf-v6-c-notification-drawer__group",
  "notificationDrawerGroupList": "pf-v6-c-notification-drawer__group-list",
  "notificationDrawerGroupToggle": "pf-v6-c-notification-drawer__group-toggle",
  "notificationDrawerGroupToggleCount": "pf-v6-c-notification-drawer__group-toggle-count",
  "notificationDrawerGroupToggleIcon": "pf-v6-c-notification-drawer__group-toggle-icon",
  "notificationDrawerGroupToggleTitle": "pf-v6-c-notification-drawer__group-toggle-title",
  "notificationDrawerHeader": "pf-v6-c-notification-drawer__header",
  "notificationDrawerHeaderAction": "pf-v6-c-notification-drawer__header-action",
  "notificationDrawerHeaderStatus": "pf-v6-c-notification-drawer__header-status",
  "notificationDrawerHeaderTitle": "pf-v6-c-notification-drawer__header-title",
  "notificationDrawerList": "pf-v6-c-notification-drawer__list",
  "notificationDrawerListItem": "pf-v6-c-notification-drawer__list-item",
  "notificationDrawerListItemAction": "pf-v6-c-notification-drawer__list-item-action",
  "notificationDrawerListItemDescription": "pf-v6-c-notification-drawer__list-item-description",
  "notificationDrawerListItemHeader": "pf-v6-c-notification-drawer__list-item-header",
  "notificationDrawerListItemHeaderIcon": "pf-v6-c-notification-drawer__list-item-header-icon",
  "notificationDrawerListItemHeaderTitle": "pf-v6-c-notification-drawer__list-item-header-title",
  "notificationDrawerListItemTimestamp": "pf-v6-c-notification-drawer__list-item-timestamp"
};